// extracted by mini-css-extract-plugin
export default {"gray-20":"rgb(221, 224, 230)","alert-success":"rgb(30, 133, 59)","icon":"styles_icon__qrEEb","check":"styles_check__wUHgh"};